export default "__VITE_ASSET__cd72845f__"